module.exports = __webpack_public_path__ + "static/media/golfer-1-a.97a71f8b.png";